/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GoalDto } from './goalDto';
import { ObservationTypeDto } from './observationTypeDto';
import { PlanTypeResponseDto } from './planTypeResponseDto';
import { WorkItemDto } from './workItemDto';
import { EncounterDto } from './encounterDto';


export interface CarePlanResponseDto { 
    /**
     * Care plan identifier
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Problem identifier
     */
    problemId: string;
    /**
     * Element identifier for plan type
     */
    elementId: string;
    /**
     * Collection identifier (care-plan-types) for Reference Data Service
     */
    collectionId: string;
    /**
     * Care plan status
     */
    status: CarePlanResponseDto.StatusEnum;
    /**
     * Care plan title
     */
    title: string;
    /**
     * Care plan description
     */
    description?: string;
    /**
     * Reason for the current status
     */
    statusReason?: string;
    /**
     * Care plan goals
     */
    goals: Array<GoalDto>;
    /**
     * Linked observation IDs
     */
    observationIds: Array<string>;
    /**
     * Care plan start date
     */
    startDate: string;
    /**
     * Care plan end date
     */
    endDate?: string;
    /**
     * The healthcare provider or clinician who is managing the care plan
     */
    managingProvider: string;
    /**
     * Additional structured metadata conforming to the plan type recordSchema
     */
    metadata?: any;
    /**
     * Creation timestamp
     */
    createdOn: string;
    /**
     * Last update timestamp
     */
    updatedOn?: string;
    /**
     * Full plan type data from Reference Data Service (only populated when expand=care-plan-type query parameter is used)
     */
    planType?: PlanTypeResponseDto;
    /**
     * Related work items
     */
    workItems?: Array<WorkItemDto>;
    /**
     * Related encounters (only populated when expand=encounters query parameter is used)
     */
    encounters?: Array<EncounterDto>;
    /**
     * Expanded observation type data from Reference Data Service (only populated when expand=observation-types query parameter is used)
     */
    expandedObservationTypes?: Array<ObservationTypeDto>;
}
export namespace CarePlanResponseDto {
    export type StatusEnum = 'open' | 'on-hold' | 'closed';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        OnHold: 'on-hold' as StatusEnum,
        Closed: 'closed' as StatusEnum
    };
}


